module.exports = __webpack_public_path__ + "static/media/TLC.b6f6f96f.svg";